/*
 * Two columns, two rows, and the sidebar spanning both rows.
 *
 * The sidebar carries the wordmark, so it starts at the top of the window and
 * the topbar starts where the sidebar ends. The alternative, a full-width
 * topbar with the sidebar beneath it, puts the wordmark in the topbar and then
 * the sidebar has nothing at its head and reads as a floating list.
 */

.shell {
  display: grid;
  grid-template-columns: var(--sidebar-w) minmax(0, 1fr);
  grid-template-rows: var(--topbar-h) minmax(0, 1fr);
  grid-template-areas:
    'sidebar topbar'
    'sidebar main';
  /*
   * A fixed height, not a minimum. This is what makes `main` the only scroll
   * container in the console, which is what sticky table headers and the
   * SplitView's independent panes both depend on. See the component header.
   */
  height: 100vh;
  /*
   * `minmax(0, 1fr)` on the column and the row is doing real work: the default
   * `auto` sizes to content, so one wide table would push the whole grid past
   * the viewport, taking the sidebar off screen to the left and putting the
   * topbar's user menu somewhere nobody can reach.
   */
  background: var(--surface);
  color: var(--text);
  transition: grid-template-columns var(--dur-fast) var(--ease-out);
}

.shell[data-collapsed='true'] {
  grid-template-columns: var(--sidebar-collapsed-w) minmax(0, 1fr);
}

/* In drawer mode the sidebar is in the top layer, not in the grid. */
.shell[data-drawer='true'] {
  grid-template-columns: minmax(0, 1fr);
  grid-template-areas:
    'topbar'
    'main';
}

.sidebar {
  grid-area: sidebar;
  display: grid;
  /* The Sidebar itself is a grid of header, nav and footer. It needs to know
     it has the full height to distribute. */
  min-height: 0;
  border-right: 1px solid var(--rule);
  background: var(--surface-sunken);
  /*
   * Not clipped. The organization switcher's menu hangs out of this column,
   * and `overflow: hidden` here would cut it off at the border. The Sidebar's
   * own nav list owns the scrolling instead, so nothing needs to overflow at
   * this level.
   */
  overflow: visible;
}

.topbar {
  grid-area: topbar;
  display: flex;
  align-items: center;
  min-width: 0;
  border-bottom: 1px solid var(--rule);
  background: var(--surface);
  /* Same reason as the sidebar: the user menu and the scheme control open
     downwards out of this bar. */
  overflow: visible;
}

.main {
  grid-area: main;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  /* For in-page anchors and for the skip link. base.css already forces this
     back to `auto` under prefers-reduced-motion, so it is not restated here. */
  scroll-behavior: smooth;
}
